import { render, staticRenderFns } from "./completedOrder.vue?vue&type=template&id=64b6e040&scoped=true"
import script from "./completedOrder.vue?vue&type=script&lang=js"
export * from "./completedOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b6e040",
  null
  
)

export default component.exports